<h1 matDialogTitle>
  {{ isNew ? ('Add API Key' | translate) : ('Edit API Key' | translate) }}
</h1>
<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <ix-input
    formControlName="name"
    [label]="'Name' | translate"
    [required]="true"
    [tooltip]="tooltips.name | translate"
  ></ix-input>

  <ix-checkbox
    *ngIf="!isNew"
    formControlName="reset"
    [label]="'Reset' | translate"
    [tooltip]="tooltips.reset | translate"
  ></ix-checkbox>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" matDialogClose>
      {{ 'Cancel' | translate }}
    </button>
    <button
      *ixRequiresRoles="requiredRoles"
      mat-button type="submit"
      color="primary"
      ixTest="save"
      [disabled]="form.invalid"
    >
      {{ 'Save' | translate }}
    </button>
  </ix-form-actions>
</form>
